/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

import { ClassRemoteDataStore, DataUtil } from 'plugin/liferay-widgets-react-web';
//import SubscriptionWebApi from '../webapi/SubscriptionWebApi';
import { ClassNames, DataNames } from '../constants/Constants';


export default class SubscriptionStore extends ClassRemoteDataStore {

    constructor(Dispatcher) {
        super(Dispatcher, ClassNames.Subscription, undefined, undefined);
    }



    getUserSubscription(topic) {
        const dataItem = this.getRemoteData(DataNames.UserSubscriptions);
        const subscriptions = DataUtil.asArray(dataItem);
        let subscription = undefined;
        subscriptions && subscriptions.forEach(sub => {
            if (sub.topic === topic) {
                subscription = sub;
            }
        });
        return subscription;
    }


    getContainedClassnames() {
        return {
            [ ClassNames.Subscription ]: true
        };
    }

}



// WEBPACK FOOTER //
// ./js/stores/SubscriptionStore.js